import { Signal } from '@angular/core';
import { Permissions } from '../../shared/constants/permissions';

export interface NavItem {
  id: string;
  label: string;
  /** Nombre de icono registrado en MatIconRegistry (core/icons). */
  icon: string;
  route?: string;
  /** Permiso requerido para ver el ítem; sin permiso → oculto (nunca deshabilitado). */
  permission?: string;
  /** Contador opcional (p. ej. leads nuevos, facturas vencidas) — Fase 9 lo alimenta con datos reales. */
  badge?: Signal<number>;
  /** Módulo aún no implementado (Fase 3+): visible pero no navegable, "(próximamente)". */
  disabled?: boolean;
  /** Solo visible fuera de producción (catálogo /ui). */
  devOnly?: boolean;
}

export interface NavSection {
  id: string;
  title: string;
  items: NavItem[];
}

/** Navegación completa del CRM — fuente única (component-library.md §1 AppSidebar). */
export const NAVIGATION: NavSection[] = [
  {
    id: 'principal',
    title: 'Principal',
    items: [
      { id: 'dashboard', label: 'Dashboard', icon: 'layout-dashboard', route: '/dashboard' },
      {
        id: 'leads',
        label: 'Leads',
        icon: 'sparkles',
        route: '/leads',
        permission: Permissions.Leads.View,
      },
      {
        id: 'clients',
        label: 'Clientes',
        icon: 'building-2',
        route: '/clients',
        permission: Permissions.Clients.View,
      },
      {
        id: 'quotes',
        label: 'Presupuestos',
        icon: 'file-text',
        route: '/quotes',
        permission: Permissions.Quotes.View,
      },
      {
        id: 'invoices',
        label: 'Facturas',
        icon: 'receipt',
        route: '/invoices',
        permission: Permissions.Invoices.View,
      },
      {
        id: 'payments',
        label: 'Pagos',
        icon: 'credit-card',
        route: '/payments',
        permission: Permissions.Payments.View,
      },
      {
        id: 'expenses',
        label: 'Gastos',
        icon: 'wallet',
        route: '/expenses',
        permission: Permissions.Expenses.View,
      },
    ],
  },
  {
    id: 'administracion',
    title: 'Administración',
    items: [
      {
        id: 'users',
        label: 'Usuarios',
        icon: 'users',
        route: '/admin/users',
        permission: Permissions.Users.Manage,
      },
      {
        id: 'roles',
        label: 'Roles y permisos',
        icon: 'shield-check',
        route: '/admin/roles',
        permission: Permissions.Roles.Manage,
      },
      {
        id: 'settings',
        label: 'Configuración',
        icon: 'settings',
        route: '/admin/settings',
        permission: Permissions.Settings.Manage,
      },
      {
        id: 'audit',
        label: 'Auditoría',
        icon: 'scroll-text',
        route: '/admin/audit',
        permission: Permissions.Audit.View,
      },
    ],
  },
  {
    id: 'dev',
    title: 'Desarrollo',
    items: [{ id: 'ui-kit', label: 'UI Kit', icon: 'grid-3x3', route: '/ui', devOnly: true }],
  },
];
